<template>
  <div
    :class="isSkione ? 'form-control-blue' : 'form-control-yellow'"
    class="cell__form-control"
  >
    <a-select
      :dropdownMatchSelectWidth="true"
      class="w-100 select-multiple"
      dropdownClassName="fitted-dropdown ux-ok"
      mode="multiple"
      :placeholder="disabled ? groupTitle : 'Wybierz kierunek'"
      ref="destid"
      :showArrow="disabled ? false : true"
      v-model="valDests"
      @change="handleChangeDest"
      :disabled="disabled"
    >
      <a-select-option
        v-for="item in filteredDests"
        :id="item.rname"
        :key="item.rlocid"
        :parent="item.parent"
        :selected="valDests.includes(item.rlocid)"
      >
        <span class="chbox-sim-indent" v-if="item.srlocid != ''"></span>
        <span><span class="chbox-sim"></span>{{ item.rname }}</span>
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import axios from "axios";
import * as CONFIG from "../config.js";
axios.defaults.withCredentials = false;

export default {
  props: {
    disabled: Boolean,
    filtryItems: Array,
    groupTitle: String,
    isSkione: Boolean,
  },
  data: () => ({
    urldests: "/getdests.json",
    destlocidarr: [],
    destarr: [],
    dests: [],
    destlocids: "",
    regionlist: {},
    valDests: [],
  }),
  methods: {
    getDests() {
      return axios
        .get(CONFIG.API_URL + this.urldests, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    handleChangeDest(value, id) {
      this.destarr.length = 0;
      let list = [];
      id.forEach(function (item, index) {
        list.push(item.data.attrs.id);
      });
      this.destarr = list;
      this.destlocidarr = value;
      let listParent = {};
      id.forEach(function (item, index) {
        listParent[item.data.attrs.parent] = true;
      });
      this.regionlist = listParent;
      let emitedLocids = this.destlocidarr;
      this.$emit("dataFromDests", emitedLocids);
      return true;
    },
    getQueryParamsDests(newParams, addon) {
      let lparams = this.$route.query;
      if (addon) {
        lparams = newParams;
      }
      if (lparams["locid"]) {
        let data = decodeURIComponent(lparams["locid"]);
        let dataArr = data.split(",");
        this.valDests = dataArr;
        this.destarr = dataArr;
        this.destlocidarr = dataArr;
        let list = this.dests;
        let listw = [];
        let _this = this;
        this.regionlist = {};
        list.forEach(function (value, index) {
          if (dataArr.includes(value.rlocid)) {
            _this.regionlist[value.parent] = true;
            listw.push(value.rname);
          }
        });
        this.destlocids = listw.join(",");
      }
    },
  },
  mounted() {
    this.getDests().then((data) => {
      //alert('DESTS:' + JSON.stringify(data.page.response));
      this.dests = data.page.response;
      for (var idx in this.dests) {
        this.$set(this.dests[idx], "checked", false);
        this.$set(this.dests[idx], "expanded", false);
      }
      this.getQueryParamsDests(null, false);
    });
    var that = this;
    this.$root.$on("update:locid", (val1) => {
      var newquery = Object.assign({}, that.$route.query);
      newquery["locid"] = val1;
      that.getQueryParamsDests(newquery, true);
    });
  },
  computed: {
    filteredDests: function () {
      if (this.dests.length > 0) {
        let assoc = this.regionlist;
        var bb = this.dests.filter(function (value, index) {
          return value.parent == value.rlocid || assoc[value.parent];
        });
        return bb;
      } else {
        return [];
      }
    },
  },
};
</script>
